import { store } from "@/store";
import Axios, { AxiosRequestConfig } from "axios";
const restEndpoint: string = process.env.VUE_APP_BACKEND;
const websocketBachendEndpoint: string = process.env.VUE_APP_WEBSOCKET_BACKEND;

export default {
  getWebsocketBackendURL() {
    return websocketBachendEndpoint;
  },
  getRequestConfig(): AxiosRequestConfig {
    const token = store.state.authentication.token;
    const config = {
      baseURL: restEndpoint,
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (token !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (config as any).headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
};
